var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.15261837610274,
    height: 46.15261837610274,
    viewBox: "136.4532444910801 154.54733375525382 46.15261837610274 46.15261837610274",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6654003158 0 0 0.6654003158 159.5295536791 177.6236429433)",
    id: "hArYxbhwATJ35Z3vs5XpL"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(39,236,227)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,234)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 0 -34.68034 C 19.14355 -34.68034 34.68034 -19.14355 34.68034 0 C 34.68034 19.14355 19.14355 34.68034 0 34.68034 C -19.14355 34.68034 -34.68034 19.14355 -34.68034 0 C -34.68034 -19.14355 -19.14355 -34.68034 0 -34.68034 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 159.5295536791 177.6236429433)",
    id: "FKc_PfY9tTnjvKFWAUgf4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.11779 0)",
    id: "FCfSaGzmblXZ-0XkA9PQr"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-15.61779, -15)",
    d: "M 4.34448 16.25 C 4.34448 20.9372 4.34448 23.2808 5.5406 24.9237 C 5.9269 25.4543 6.39448 25.9209 6.92617 26.3064 C 8.57249 27.5 10.9209 27.5 15.6178 27.5 C 20.3147 27.5 22.6631 27.5 24.3095 26.3064 C 24.8412 25.9209 25.3087 25.4543 25.695 24.9237 C 26.8911 23.2808 26.8911 20.9372 26.8911 16.25 L 26.8911 13.75 C 26.8911 12.7013 26.8911 11.77 26.8778 10.9375 L 26.7899 10.9375 C 25.7227 10.9376 25.0726 10.9376 24.5119 10.849 C 21.43 10.3619 19.0129 7.94985 18.5248 4.87437 C 18.436 4.31478 18.4361 3.66605 18.4361 2.60103 L 18.4361 2.51337 C 17.602 2.5 16.6687 2.5 15.6178 2.5 C 10.9209 2.5 8.57249 2.5 6.92617 3.69364 C 6.39448 4.07914 5.9269 4.54575 5.5406 5.07634 C 4.34448 6.71925 4.34448 9.06283 4.34448 13.75 L 4.34448 16.25 Z M 10.6074 9.0625 C 10.0886 9.0625 9.668 9.48223 9.668 10 C 9.668 10.5178 10.0886 10.9375 10.6074 10.9375 L 14.3652 10.9375 C 14.8841 10.9375 15.3047 10.5178 15.3047 10 C 15.3047 9.48223 14.8841 9.0625 14.3652 9.0625 L 10.6074 9.0625 Z M 10.6074 14.0625 C 10.0886 14.0625 9.668 14.4822 9.668 15 C 9.668 15.5178 10.0886 15.9375 10.6074 15.9375 L 20.6282 15.9375 C 21.147 15.9375 21.5676 15.5178 21.5676 15 C 21.5676 14.4822 21.147 14.0625 20.6282 14.0625 L 10.6074 14.0625 Z M 10.6074 19.0625 C 10.0886 19.0625 9.668 19.4822 9.668 20 C 9.668 20.5178 10.0886 20.9375 10.6074 20.9375 L 14.3652 20.9375 C 14.8841 20.9375 15.3047 20.5178 15.3047 20 C 15.3047 19.4822 14.8841 19.0625 14.3652 19.0625 L 10.6074 19.0625 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.06215 -9.17792)",
    id: "KU8Gctemr7irepDk439jw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-23.56215, -5.82208)",
    d: "M 24.8058 8.99709 C 25.1921 9.05815 25.669 9.06233 26.8093 9.06249 C 26.6911 7.26297 26.4019 6.04729 25.695 5.07634 C 25.3087 4.54575 24.8412 4.07914 24.3095 3.69364 C 23.3365 2.98821 22.1183 2.69968 20.315 2.58167 C 20.3152 3.71959 20.3194 4.19557 20.3806 4.58106 C 20.7414 6.85424 22.5279 8.63706 24.8058 8.99709 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order_icon.e517e2e0ea5a546a2ee620f858650113.svg";
export { ForwardRef as ReactComponent };